export const DRAWER_WIDTH = 240;
export const DRAWER_WIDTH_MINI = 65;
